import { ApolloLink, ServerError } from '@apollo/client';
import { onError, ErrorResponse } from '@apollo/client/link/error';
import { fromPromise } from '@apollo/client/link/utils';
import { ISessionService } from './SessionService';
import { ITokenService } from './TokenService';

const errorLink = (tokenService: ITokenService, sessionService: ISessionService): ApolloLink => {
    return onError(({ graphQLErrors, networkError, operation, forward }: ErrorResponse) => {
        if (networkError) {
            const { statusCode } = networkError as ServerError;

            switch (statusCode) {
                case 404: {
                    console.error(`[Network error]: Server not found`);
                    break;
                }
                case 401: {
                    console.error(`[Network error]: Unauthorized access`);
                    const context = operation.getContext();
                    if (context.__refreshAttempted) {
                        sessionService.logoff();
                        break;
                    }

                    operation.setContext({ ...context, __refreshAttempted: true });

                    return fromPromise(
                        tokenService.forceRefreshToken().catch((error) => {
                            sessionService.logoff();
                            throw error;
                        }),
                    ).flatMap(() => forward(operation));
                }
                case 403: {
                    console.error(`[Network error]: Unauthorized access`);
                    const context = operation.getContext();
                    if (context.__refreshAttempted) {
                        sessionService.logoff();
                        break;
                    }

                    operation.setContext({ ...context, __refreshAttempted: true });

                    return fromPromise(
                        tokenService.forceRefreshToken().catch((error) => {
                            sessionService.logoff();
                            throw error;
                        }),
                    ).flatMap(() => forward(operation));
                }
                default: {
                    console.error(`[Network error]: ${networkError}`);
                }
            }
        }

        if (graphQLErrors) {
            graphQLErrors.forEach(({ message, locations, path }) => {
                console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
            });
        }
    });
};

export default errorLink;
